import { render, staticRenderFns } from "./message-plugin-layout.vue?vue&type=template&id=03370410&scoped=true"
import script from "./message-plugin-layout.vue?vue&type=script&lang=ts"
export * from "./message-plugin-layout.vue?vue&type=script&lang=ts"
import style0 from "./message-plugin-layout.vue?vue&type=style&index=0&id=03370410&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03370410",
  null
  
)

export default component.exports